module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/future_bg.032919ff.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/future_bg.png
// module id = 2855
// module chunks = 11